import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import useAuth from '../../auth/useAuth';
import { generalInfoQuery, scenarioLevelsQuery, scenarioLevelsItemsViewQuery } from './api';
import Game from './index';
import GameScramble from './scramble';
import GameMultiStep from './multistep';

export default function ClassificationRouter() {
  const params = useParams();
  const levelNumber = Number(params.levelNumber);
  
  const { getCurrentClassificationGameId } = useAuth();
  const gameId = getCurrentClassificationGameId();

  const { data: generalInfo, isLoading: gamesLoading } = useQuery(generalInfoQuery());
  const games = generalInfo?.games;
  
  const game = games?.find(g => g.game_type.includes('Account Classification') && g.id === gameId);
  const scenarioId = game?.scenario;

  const { data: scenarioLevels, isLoading: levelsLoading } = useQuery({
    ...scenarioLevelsQuery({ scenarioId }),
    enabled: !!scenarioId,
  });

  const { data: answerData, isLoading: answerDataLoading } = useQuery({
    ...scenarioLevelsItemsViewQuery(scenarioId),
    enabled: !!scenarioId,
  });

  if (gamesLoading || !scenarioId || levelsLoading || answerDataLoading) {
    return null;
  }

  const currentLevel = scenarioLevels?.find(scenarioLevel => scenarioLevel.level === levelNumber);

  if (!currentLevel) {
    console.warn(`Level ${levelNumber} not found in scenarioLevels`);
    return <Game levelNumber={levelNumber} scenarioLevels={scenarioLevels} answerData={answerData} />;
  }

  const isScrambleLevel = currentLevel?.name?.toLowerCase().includes('scramble');
  const isMultiStepLevel = currentLevel?.name === 'classified-multistep'
    || currentLevel?.design?.includes?.('4')
    || currentLevel?.design?.includes?.('5');

  if (isMultiStepLevel) {
    return <GameMultiStep key={levelNumber} levelNumber={levelNumber} scenarioLevels={scenarioLevels} answerData={answerData} />;
  }

  if (isScrambleLevel) {
    return <GameScramble key={levelNumber} levelNumber={levelNumber} scenarioLevels={scenarioLevels} />;
  }

  return <Game key={levelNumber} levelNumber={levelNumber} scenarioLevels={scenarioLevels} answerData={answerData} />;
}